import { useState, useEffect } from 'react';
import { apiFetch, handleApiError } from '../../utils/apiClient';

export const useApplianceDetails = () => {
  const [applianceId, setApplianceId] = useState<string>('');
  const [encryptionVersion, setEncryptionVersion] = useState<string | null>(null);
  const [blocksize, setBlocksize] = useState<string | null>(null);
  const [userName, setUserName] = useState<string | null>(null);

  useEffect(() => {
    const fetchApplianceDetails = async () => {
      try {
        const response = await apiFetch('Admin/Home/GetApplianceAndUserInfo', {
          method: 'GET'
        });
        if (!response.ok) {
          await handleApiError(response);
        }
        const data = await response.json();
        setApplianceId(data.applianceId);
        setEncryptionVersion(data.encryptionVersion || null);
        setBlocksize(data.blocksize || null);
        setUserName(data.userName || null);
      } catch (error) {
        console.error('Error fetching appliance ID:', error);
      }
    };


    fetchApplianceDetails();
  }, []);

  return { applianceId, encryptionVersion, blocksize, userName };
};

export default useApplianceDetails;
